import { Toaster } from 'react-hot-toast'
import type { RouteObject } from 'react-router-dom'
import { Link, useLocation, useRoutes } from 'react-router-dom'
import { useState } from 'react'
import { DEMO_AVAILABLE, enterDemo, exitDemo, resetDemo, getDemoRole, type DemoRole } from '@/lib/demo'
import { isDemoMode } from '@/lib/lumi'
import Home from '@/pages/Home'
import AssinaturaTeste from '@/pages/AssinaturaTeste'
import Cadastro from '@/pages/Cadastro'
import Perfil from '@/pages/Perfil'
import Curriculo from '@/pages/Curriculo'
import Vagas from '@/pages/Vagas'
import Gastronomia from '@/pages/Gastronomia'
import Marketplace from '@/pages/Marketplace'
import MarketplaceUsuario from '@/pages/MarketplaceUsuario'
import CriarVaga from '@/pages/CriarVaga'
import BuscarUsuarios from '@/pages/BuscarUsuarios'
import PerfilPublico from '@/pages/PerfilPublico'
import Feed from '@/pages/Feed'
import CompletarCadastro from '@/pages/CompletarCadastro'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/assinatura-teste', element: <AssinaturaTeste /> },
  ...(DEMO_AVAILABLE ? [{ path: '/demo', element: <DemoPage /> }] : []),
  { path: '/cadastro', element: <Cadastro /> },
  { path: '/completar-cadastro', element: <CompletarCadastro /> },
  { path: '/perfil', element: <Perfil /> },
  { path: '/perfil/:usuarioId', element: <PerfilPublico /> },
  { path: '/curriculo', element: <Curriculo /> },
  { path: '/vagas', element: <Vagas /> },
  { path: '/gastronomia', element: <Gastronomia /> },
  { path: '/marketplace', element: <Marketplace /> },
  { path: '/marketplace/usuario/:usuarioId', element: <MarketplaceUsuario /> },
  { path: '/criar-vaga', element: <CriarVaga /> },
  { path: '/buscar-usuarios', element: <BuscarUsuarios /> },
  { path: '/feed', element: <Feed /> },
]

function DemoPage() {
  const [error, setError] = useState('');
  const start = (role: DemoRole) => {
    try { enterDemo(role); } catch { setError('Não foi possível iniciar. Permita o armazenamento nesta aba e tente novamente.'); }
  };
  return <main className="min-h-screen bg-[#171717] text-white px-4 py-12">
    <div className="max-w-xl mx-auto rounded-2xl border border-amber-500/40 p-6 sm:p-9">
      <p className="text-amber-300 text-sm mb-3">BBQ Jobs · Demonstração</p>
      <h1 className="text-3xl font-bold mb-4">Experimente os dois perfis</h1>
      <p className="text-gray-300 mb-6">Use somente informações fictícias. Vagas, candidaturas, fotos e mensagens ficam nesta aba e não são enviadas a pessoas reais. Nenhuma conta é criada e não há pagamentos.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <button className="rounded-xl bg-[#E53935] p-4 font-semibold" onClick={() => start('trabalhador')}>Testar como trabalhador</button>
        <button className="rounded-xl bg-[#333] p-4 font-semibold" onClick={() => start('restaurante')}>Testar como estabelecimento</button>
      </div>
      {error && <p role="alert" className="mt-4 text-red-300">{error}</p>}
      <Link to="/cadastro" className="inline-block mt-6 underline">Voltar ao cadastro</Link>
    </div>
  </main>;
}

function DemoBanner() {
  const [error, setError] = useState('');
  const run = (action: () => void) => { try { action(); } catch { setError('Não foi possível alterar a demonstração. Tente recarregar a página.'); } };
  return <aside className="bg-amber-200 text-black px-4 py-3 text-sm border-b border-amber-400">
    <div className="max-w-7xl mx-auto flex flex-wrap items-center gap-3">
      <strong>Demonstração · {getDemoRole() === 'restaurante' ? 'Estabelecimento' : 'Trabalhador'}</strong>
      <span>Dados fictícios nesta aba. Stripe desativado.</span>
      <Link className="underline" to="/demo">Trocar perfil</Link>
      <button className="underline" onClick={() => { if (window.confirm('Reiniciar apenas os dados fictícios desta demonstração?')) run(resetDemo); }}>Reiniciar demonstração</button>
      <button className="underline font-bold" onClick={() => run(exitDemo)}>Sair da demonstração</button>
    </div>
    {error && <p role="alert">{error}</p>}
  </aside>;
}

function App() {
  const element = useRoutes(routes)
  const location = useLocation()
  return (
    <>
      <Toaster position="top-center" />
      {isDemoMode && <DemoBanner />}
      {!isDemoMode && DEMO_AVAILABLE && location.pathname.replace(/\/+$/, '') === '/cadastro' && <div className="bg-amber-100 text-black text-center p-3 text-sm"><Link to="/demo" className="underline font-semibold">Conhecer o site sem cadastro — demonstração</Link></div>}
      {element}
    </>
  )
}

export default App
